var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DevNotes',[_vm._v(" Communication Center : 40% "),_c('div',[_vm._v("Progression : Dev 40% / Test 0%")]),_vm._v(" Development Notes - รับ Notification จากระบบแชท ")]),_c(_vm.getCurrentStage().k,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }